import React, { useEffect, useState } from "react";
import ProductCard from "./productCard";
import { Link } from "react-router-dom";
// import { GoInbox } from "react-icons/go";

type Product = {
  id: number;
  name: string;
  price: number;
  stock: number;
  product_images: {
    image_path: string;
  }[];
};

const Allproduk: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [perPage, setPerPage] = useState(6);

  // 🔹 Tentukan per_page berdasarkan screen
  const calculatePerPage = () => {
    const width = window.innerWidth;

    if (width >= 1024) return 100; // desktop
    if (width >= 768) return 100; // tablet
    return 100; // mobile
  };

  // 🔹 Update per_page saat resize
  useEffect(() => {
    const handleResize = () => {
      setPerPage(calculatePerPage());
    };

    setPerPage(calculatePerPage());
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔹 Fetch data sesuai per_page
  useEffect(() => {
    setLoading(true);

    fetch(`https://api.belaskasih.com/api/v1/products?pagination=true&per_page=${perPage}`)
      .then((res) => res.json())
      .then((res) => {
        setProducts(res.data.data || []);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [perPage]);
  return (
    <section className="py-10">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        {/* HEADER */}
        <div className="text-center mb-12 flex flex-col justify-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#131010]">
            Donasi <span className="text-red-500 font-bilbo">Barang</span>
          </h2>
          <p className="mt-2 text-xs md:text-sm max-w-xl mx-auto text-center text-gray-600">Beli dan pilih sendiri barang yang kamu donasikan, Relawan akan mengirimkannya!</p>
          <div className="flex  justify-center mt-4">
            <Link to={"https://mitra.belaskasih.com/login"} target="_blank">
              <div className="border-2 border-red-500 text-red-500 font-semibold px-7 py-2 rounded-xl flex justify-center gap-2 items-center">
                Galang Dana Donasi Barang
                {/* <GoInbox /> */}
              </div>
            </Link>
          </div>
        </div>

        {/* LIST */}
        {loading ? (
          <div className="flex justify-center items-center py-20 gap-2">
            <span className="w-3 h-3 bg-red-500 rounded-full animate-bounce [animation-delay:-0.3s]" />
            <span className="w-3 h-3 bg-red-500 rounded-full animate-bounce [animation-delay:-0.15s]" />
            <span className="w-3 h-3 bg-red-500 rounded-full animate-bounce" />
          </div>
        ) : (
          <div
            className="
              grid
              grid-cols-2
              md:grid-cols-4
              lg:grid-cols-6
              gap-4
            ">
            {products.map((item) => (
              <ProductCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Allproduk;
